import { useResendReceiptMutation } from '../transactionsApi';
import { enqueueSnackbar } from 'notistack';
import i18next from 'i18next';

export const useTransactionsActions = () => {
  const [resendReceiptTrigger] = useResendReceiptMutation();

  const resendReceipt = async (id) => {
    try {
      const result = await resendReceiptTrigger(id).unwrap();
      enqueueSnackbar(i18next.t('transactions.receiptSent'), { variant: 'success' });
      return result;
    } catch (error) {
      enqueueSnackbar(i18next.t('transactions.receiptSentFailed'), { variant: 'error' });
      throw error;
    }
  };

  return {
    resendReceipt,
  };
};

